import { defineComponent, ref, computed, watch, onMounted, onUnmounted } from "vue";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import { useRoomStore } from "../../../stores/room.mjs";
import useRoomControl from "./useRoomControlHooks.mjs";
import "../../../directives/vTap.mjs";
import CreateRoomIcon from "../../common/icons/CreateRoomIcon.vue.mjs";
import EnterRoomIcon from "../../common/icons/EnterRoomIcon.vue.mjs";
import ArrowStrokeBackIcon from "../../common/icons/ArrowStrokeBackIcon.vue.mjs";
import ArrowStrokeSelectDownIcon from "../../common/icons/ArrowStrokeSelectDownIcon.vue.mjs";
import ScheduleRoomIcon from "../../common/icons/ScheduleRoomIcon.vue.mjs";
import ScheduleRoomList from "../../ScheduleConference/ScheduleRoomList.vue.mjs";
import ScheduleConferencePanel from "../../ScheduleConference/ScheduleConferencePanel/index.mjs";
import renderMsg from "../../common/base/Message/Message.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RoomControlH5",
  props: {
    userName: null,
    givenRoomId: null
  },
  emits: ["create-room", "enter-room", "update-user-name"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const { t } = useRoomControl();
    const moreTypeRef = ref();
    const roomStore = useRoomStore();
    const showRoomDetail = ref(false);
    const showMoreType = ref(false);
    const showScheduleRoom = ref(false);
    const isJoinRoom = ref(false);
    const roomType = computed(
      () => mode.value === "FreeToSpeak" ? t("Free Speech Room") : t("On-stage Speaking Room")
    );
    const isMicOn = ref(true);
    const isCamerOn = ref(true);
    const mode = ref("FreeToSpeak");
    const tuiRoomParam = {
      isOpenCamera: true,
      isOpenMicrophone: true,
      defaultCameraId: "",
      defaultMicrophoneId: "",
      defaultSpeakerId: ""
    };
    expose({
      getRoomParam
    });
    const currentUserName = ref();
    watch(
      () => props.userName,
      (val) => {
        currentUserName.value = val ? val : `user_${Math.ceil(Math.random() * 10)}`;
      },
      { immediate: true }
    );
    const currentRoomId = ref(props.givenRoomId);
    const hasGivenRoomId = computed(
      () => typeof currentRoomId.value === "string" && currentRoomId.value !== ""
    );
    function createRoom() {
      showRoomDetail.value = !showRoomDetail.value;
      isJoinRoom.value = false;
    }
    function enterRoom() {
      showRoomDetail.value = !showRoomDetail.value;
      isJoinRoom.value = true;
    }
    function scheduleRoom() {
      showScheduleRoom.value = !showScheduleRoom.value;
    }
    function chooseRoomType() {
      showMoreType.value = !showMoreType.value;
    }
    function chooseCurrentType(roomType2) {
      mode.value = roomType2;
    }
    function handleConfirm() {
      showMoreType.value = !showMoreType.value;
    }
    function handleClose() {
      currentRoomId.value = "";
      showRoomDetail.value = false;
      showMoreType.value = false;
    }
    function toggle(type) {
      switch (type) {
        case "isMicOn":
          isMicOn.value = !isMicOn.value;
          tuiRoomParam.isOpenMicrophone = isMicOn.value;
          break;
        case "isCamerOn":
          isCamerOn.value = !isCamerOn.value;
          tuiRoomParam.isOpenCamera = isCamerOn.value;
          break;
      }
    }
    function getRoomParam() {
      tuiRoomParam.defaultCameraId = roomStore.currentCameraId;
      tuiRoomParam.defaultMicrophoneId = roomStore.currentMicrophoneId;
      tuiRoomParam.defaultSpeakerId = roomStore.currentSpeakerId;
      return tuiRoomParam;
    }
    function handleInput(e) {
      currentRoomId.value = e.target.value;
    }
    function handleDocumentClick(event) {
      if (showMoreType.value && !moreTypeRef.value.contains(event.target)) {
        showMoreType.value = false;
      }
    }
    function handleRoomOption(type, params) {
      const roomParam = getRoomParam();
      switch (type) {
        case "Join":
          if (!currentRoomId.value && !(params == null ? void 0 : params.roomId)) {
            renderMsg({
              type: "error",
              message: t("Please enter the room number")
            });
            return;
          }
          emit(
            "enter-room",
            params || {
              roomId: String(currentRoomId.value),
              roomParam
            }
          );
          break;
        case "New":
          emit("create-room", {
            roomMode: mode.value,
            roomParam,
            isSeatEnabled: Boolean(mode.value === "SpeakAfterTakingSeat")
          });
          break;
      }
    }
    onMounted(() => {
      document == null ? void 0 : document.addEventListener("click", handleDocumentClick, true);
    });
    onUnmounted(() => {
      document == null ? void 0 : document.removeEventListener("click", handleDocumentClick, true);
    });
    return { __sfc: true, t, moreTypeRef, roomStore, showRoomDetail, showMoreType, showScheduleRoom, isJoinRoom, roomType, isMicOn, isCamerOn, mode, tuiRoomParam, emit, props, currentUserName, currentRoomId, hasGivenRoomId, createRoom, enterRoom, scheduleRoom, chooseRoomType, chooseCurrentType, handleConfirm, handleClose, toggle, getRoomParam, handleInput, handleDocumentClick, handleRoomOption, SvgIcon, CreateRoomIcon, EnterRoomIcon, ArrowStrokeBackIcon, ArrowStrokeSelectDownIcon, ScheduleRoomIcon, ScheduleRoomList, ScheduleConferencePanel };
  }
});
export {
  _sfc_main as default
};
